<script>
//ToggleButton.vue

import {BFormRadioGroup} from 'bootstrap-vue'

export default {
    components: {
        BFormRadioGroup
    },
    props: {
        facetTitle: {
            type: String,
            required: true
        },
        filter: {
            type: Object,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        limitOptions: {
            type: Number,
            required: true
        },
        value: {
            type: String,
        },
        filterOptions: {
            type: Boolean,
            default: false,
        },
        showCounts: {
            type: Boolean,
            default: true,
        },
        defaultOption: String,
    },
    data() {
        return {
            id: _.uniqueId(),
            selectedValue: this.value ?? null,
        }
    },
    created() {
        if (!this.defaultOption) {
            if (!this.options.find(option => {
                return option.text === 'Alle'
            })) {
                this.options.unshift({text: 'Alle', value: null});
            }
        }
    },
    watch: {
        value(newValue) {
            this.selectedValue = newValue ?? this.defaultOption;
        },
        selectedValue(value) {
            this.$emit('input', value);
            this.$emit('search');
        }
    },

}
</script>

<template>
    <div>
        <div class="toggle-buttons">
            <b-form-radio-group
                :id="'button-radios-'+id"
                v-model="selectedValue"
                :options="options"
                :name="'radios-btn-'+facetTitle"
                button-variant="madeleine"
                buttons
            ></b-form-radio-group>
        </div>
        <!--
        <div class="btn-group" data-toggle="buttons"  :v-model="selectedValue">
            <label :for="id+'_'+option.value" class="btn btn-madeleine"
                   v-for="(option) in options">
                <input type="radio"
                       :name="'radios-btn-'+facetTitle"
                       :id="id+'_'+option.value"
                      :value="option.value"
                       :v-model="selectedValue"
                >
                <span class="glyphicon glyphicon-ok"></span> {{ option.text }}
            </label>
        </div>
        -->
    </div>
</template>

<style>

.toggleButton {
    padding: 4px;
    margin: 0;
}

.title {
    cursor: pointer;
    font-weight: bold;
    color: #7a797b;
}

.title span i {
    margin-left: 5px;
    color: #c4c4c4;
}

.allselect {
    font-weight: bold;
    font-style: italic;
    color: #7a797b;
}

.search-wrapper, .toggle-buttons {
    margin-top: 8px;
}

.singleList {
    padding: 4px;
    margin: 0;
}

.content {
}

.toggle-buttons,
.toggle-buttons:active,
.toggle-buttons:focus,
.btn-group-toggle,
.btn-group-toggle:active,
.btn-group-toggle:focus {
    outline: 0 !important;
}

.btn-madeleine span.glyphicon {
    opacity: 0;
}

.btn-madeleine.active span.glyphicon {
    opacity: 1;
}

.btn-madeleine {
    color: #FFFFFF;
    background-color: #A39577;
    border-color: #A39577;
}

.btn-madeleine:hover,
.btn-madeleine:focus,
.btn-madeleine:active,
.btn-madeleine.active.focus,
.open .dropdown-toggle.btn-madeleine {
    color: #FFFFFF;
    background-color: #8F8060;
    border-color: #8F8060;
}

.btn-madeleine:active,
.btn-madeleine.active,
.open .dropdown-toggle.btn-madeleine {
    background-image: none;

}

.btn-madeleine,
.btn-madeleine:active,
.btn-madeleine.active.focus,
.btn-madeleine:focus {
    outline: 0 !important;
}

.btn-madeleine.disabled,
.btn-madeleine[disabled],
fieldset[disabled] .btn-madeleine,
.btn-madeleine.disabled:hover,
.btn-madeleine[disabled]:hover,
fieldset[disabled] .btn-madeleine:hover,
.btn-madeleine.disabled:focus,
.btn-madeleine[disabled]:focus,
fieldset[disabled] .btn-madeleine:focus,
.btn-madeleine.disabled:active,
.btn-madeleine[disabled]:active,
fieldset[disabled] .btn-madeleine:active,
.btn-madeleine.disabled.active,
.btn-madeleine[disabled].active,
fieldset[disabled] .btn-madeleine.active {
    background-color: #A39577;
    border-color: #A39577;
}

.btn-madeleine .badge {
    color: #A39577;
    background-color: #FFFFFF;
}

.toggle-buttons input[type='radio']:after {
    width: 14px;
    height: 14px;
    border-radius: 14px;
    top: -2px;
    left: -1px;
    position: relative;
    background-color: #A39577;
    content: '';
    display: inline-block;
    visibility: visible;

}

.toggle-buttons input[type='radio']:checked:after {
    width: 14px;
    height: 14px;
    border-radius: 14px;
    top: -2px;
    left: -1px;
    position: relative;
    background-color: #8F8060;
    content: '';
    display: inline-block;
    visibility: visible;
}

.toggle-buttons input[type='radio']:hover:after {
    width: 14px;
    height: 14px;
    border-radius: 14px;
    top: -2px;
    left: -1px;
    position: relative;
    background-color: #8F8060;
    content: '';
    display: inline-block;
    visibility: visible;
}
</style>
